// extracted by mini-css-extract-plugin
module.exports = {"subscriptionVoucherWarnModal":"co","header":"cp","body":"cq","buttonRow":"cr","buttonWrapper":"cs","button":"ct","error":"cu"};